import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';
import ModalTemplate from "../../Wrappers/ModalTemplate";
import FormInput from "../../Atoms/Templates/FormInput";
import Select from "../../Atoms/Forms/Select";
import TooltipContainer from "../Containers/TooltipContainer";
import Tooltip from "../../Atoms/Templates/Tooltip";

const InvitedUserModal = forwardRef((props, ref) => {
  const handleCloseModal = () => {
    ref.current.closeModal()
  }

  return (
    <ModalTemplate
      ref={ref}
      className="s-main-center s-center medium"
    >
      <h3>Nuevo usuario</h3>
      <p className="small">Cuando agregues un nuevo usuario, éste tendrá acceso a la información de tu empresa y podrá
        ayudarte a manejar
        la nómina.
        <TooltipContainer>
          <span className="s-color-blue">(dependiendo del rol que le otorgues)</span>
          <Tooltip className="s-column s-left">
            <p className="s-mb-0 whitespace-nowrap">Propietario
              - <span className="s-color-light-text">Control total</span></p>
            <p className="s-mb-0 whitespace-nowrap">Administrador - <span className="s-color-light-text">Control de nóminas</span>
            </p>
            <p className="s-mb-0 whitespace-nowrap">Invitado - <span className="s-color-light-text">Solo visualizar y descargar datos</span>
            </p>
          </Tooltip>
        </TooltipContainer>
      </p>
      <form action="#"
        className="s-mb-0 ed-grid rows-gap form-grid">
        <FormInput type="email"
          label="Correo electrónico"
          isRequired
          placeholder="juan@example.com"
        />
        <Select name="#"
          placeholder
          label="Rol del usuario">
          <option value="#">Propietario</option>
          <option value="#">Administrador</option>
          <option value="#">Invitado</option>
        </Select>
        <div className="buttons-container">
          <button className="button cancel" onClick={handleCloseModal}>Cancelar</button>
          <button className="button" disabled>Invita al usuario</button>
        </div>
      </form>
    </ModalTemplate>
  );
})

InvitedUserModal.propTypes = {};

export default InvitedUserModal;
